const bullets = new Swiper("#bullets", {
    loop: true,
  speed: 1000, 
  autoplay: {
    delay: 3000, 
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination", 
    type: "bullets",
    clickable: "clickable"
  }
});
const fraction = new Swiper("#fraction", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination", 
    type: "fraction"
  }
});
const progressbar = new Swiper("#progressbar", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar"
  }
});